import React from 'react';

const AdjustIcon = (props) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path fill="#2B73C7" d="M14.846 1.899c-.111 0-.224.043-.31.129L1.778 14.858c-.41.413-.712.922-.879 1.48l-.885 2.97c-.019.063-.019.128 0 .19.042.144.173.237.314.237.032 0 .064-.005.095-.014l2.95-.891c.557-.168 1.064-.472 1.475-.886l12.757-12.83c.171-.172.171-.45 0-.623l-2.45-2.463v-.001c-.085-.085-.197-.128-.309-.128m0 1.116l1.777 1.788L4.2 17.296c-.302.305-.679.531-1.09.654l-1.91.577.575-1.924c.123-.413.348-.792.65-1.096L14.846 3.015" />
      <g transform="translate(14.165)">
        <path fill="#2B73C7" d="M2.743.221c-.335 0-.67.129-.927.386L.348 2.084c-.17.172-.17.45 0 .622l2.44 2.454.002.001c.086.085.196.128.308.128.111 0 .224-.043.309-.129l1.468-1.477c.512-.515.512-1.349 0-1.864L3.67.607 3.668.605C3.412.35 3.078.22 2.743.22m0 .918c.06 0 .173.015.272.108l.009.008 1.204 1.213c.156.156.156.41 0 .566l-1.13 1.138L1.33 2.395l1.133-1.14c.101-.1.219-.116.28-.116" mask="url(#prefix__b)" />
      </g>
      <path stroke="#2B73C7" d="M4.12 17.944l-.002-.001-2.44-2.454" />
    </g>
  </svg>
);

export default AdjustIcon;
